/* globals $ */

'use strict';

var ajaxSearch;
function search() {
  var rawQuery = $('#fund-search-input').val();
  var query = encodeURI(rawQuery);
  var searchContainer = $('#search-item-container');
  var defaultContainer = $('#default-item-container');

  if (query === undefined || query === '') {
    searchContainer.hide();
    defaultContainer.show();
  } else {
    if (ajaxSearch) {
      ajaxSearch.abort();
    }

    $('#search-spinner').css('opacity', '1');

    ajaxSearch = $.ajax({
      type: 'GET',
      url: '/fonder/search?q=' + query,
      contentType: 'application/json',
    })
      .done(function (response) {
        $('#search-spinner').css('opacity', '0');
        searchContainer.empty();
        searchContainer.show();
        defaultContainer.hide();

        if (response.length === 0) {
          searchContainer.append(
            '<div class="no-results"><p>Inga resultat</p></div>',
          );
        }

        // Define a regexp for marking all query substrings in the search
        // result. We must regexp escape the query before using it as part
        // of the expression. The raw query "foo bar$ ba/z" becomes the
        // regexp /(foo|bar\$|ba\/z)/ig.
        var queryRE = new RegExp(
          '(' +
            rawQuery
              .trim()
              .split(/\s+/g)
              .reduce(function (re, q) {
                return re + '|' + q.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
              }) +
            ')',
          'ig',
        );

        response.forEach(function (item) {
          var name = item.name.replace(queryRE, '<mark>$&</mark>');
          searchContainer.append(
            '<a href="/' +
              item.link +
              '">' +
              '<div class="item"><span class="item-name fund">' +
              name +
              '</span>' +
              '<span class="icon-right-arrow"></span></div></a>',
          );
        });
      })
      .fail(function (error) {
        $('#search-spinner').css('opacity', '0');
        if (error.statusText !== 'abort') {
          console.error('error on search fund', error);
        }
      });
  }
}

$(function () {
  search();
  var timer;
  $('#fund-search-input').bind('change paste keyup', function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      search();
    }, 150);
  });
});
